<template>
  <div ref="wrapper" class="wrapper">
    <input
      data-test-id="input-eva"
      class="eva"
      type="range"
      min="0"
      max="10"
      :value="valor || '1'"
      @input="$emit('atualizar', $event.target.value)"
    />
    <div class="descricao">
      {{ descricao }}
    </div>
    <div
      v-for="step in 11"
      :key="step"
      class="marca"
      :data-step="step - 1"
      @click="$emit('atualizar', (step - 1).toString())"
    >
      {{ step - 1 }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    valor: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      marcasPos: [],
    }
  },
  computed: {
    descricao() {
      switch (parseInt(this.valor, 10)) {
        case 0:
          return 'Nenhuma'
        case 1:
          return 'Pouca'
        case 2:
          return 'Pouca'
        case 3:
          return 'Pouca'
        case 4:
          return 'Razoável'
        case 5:
          return 'Razoável'
        case 6:
          return 'Razoável'
        case 7:
          return 'Muito'
        case 8:
          return 'Muito'
        case 9:
          return 'Muito'
        case 10:
          return 'Intensa'
        default:
          return ''
      }
    },
  },
  watch: {
    valor() {
      this.renderDescricao()
    },
  },
  mounted() {
    this.render()
    window.addEventListener('resize', this.render)
  },
  destroyed() {
    window.removeEventListener('resize', this.render)
  },
  methods: {
    render() {
      this.renderDescricao()
      this.renderMarcas()
    },
    renderDescricao() {
      const descricaoElem = this.$refs.wrapper.querySelector('.descricao')
      const descricaoElemWidth = descricaoElem.getBoundingClientRect().width
      if (parseInt(this.valor, 10) >= 7) {
        descricaoElem.setAttribute(
          'style',
          `left: ${this.marcasPos[this.valor] - descricaoElemWidth}px`
        )
      } else {
        descricaoElem.setAttribute(
          'style',
          `left: ${this.marcasPos[this.valor]}px`
        )
      }
    },
    renderMarcas() {
      const totalMarcas = 11
      const larguraWrapper = this.$refs.wrapper.getBoundingClientRect().width
      const step = larguraWrapper / totalMarcas

      for (let index = 0; index <= totalMarcas; index++) {
        const marca = this.$refs.wrapper.querySelector(
          `div[data-step="${index}"]`
        )
        const left = step * index + (step / totalMarcas) * index
        this.marcasPos[index] = left

        if (marca) {
          marca.setAttribute('style', `left: ${left}px`)
        }
      }
    },
  },
}
</script>

<style>
.wrapper {
  position: relative;
  margin: 20px 0px;
}

.descricao {
  position: absolute;
  top: 16px;
  left: 0;
  height: 24px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

.marca {
  position: absolute;
  top: -18px;
  left: 0;
  height: 24px;
  cursor: pointer;
}

.eva {
  cursor: pointer;
  background: none;
}

.eva,
.eva::-webkit-slider-runnable-track,
.eva::-webkit-slider-thumb {
  -webkit-appearance: none;
}

.eva::-webkit-slider-runnable-track {
  height: 8px;
  background: linear-gradient(90deg, #18bc9c, #f39c12, #e74c3c);
  border-radius: 0.5em;
}

.eva::-moz-range-track {
  height: 8px;
  background: linear-gradient(90deg, #18bc9c, #f39c12, #e74c3c);
  border-radius: 0.5em;
}

.eva::-ms-track {
  height: 8px;
  color: transparent;
  background: linear-gradient(90deg, #18bc9c, #f39c12, #e74c3c);
  border: none;
  border-radius: 0.5em;
}

.eva::-ms-fill-lower,
.eva::-ms-tooltip {
  display: none;
}

.eva::-webkit-slider-thumb {
  width: 16px;
  height: 16px;
  margin-top: -4px;
  cursor: ew-resize;
  background: #008080;
  border: none;
  border-radius: 100%;
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 0.1),
    0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.eva::-moz-range-thumb {
  width: 16px;
  height: 16px;
  cursor: ew-resize;
  background: #008080;
  border: none;
  border-radius: 100%;
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 0.1),
    0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.eva::-ms-thumb {
  width: 16px;
  height: 16px;
  cursor: ew-resize;
  background: #008080;
  border: none;
  border-radius: 100%;
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 0.1),
    0 1px 2px -1px rgb(0 0 0 / 0.1);
}
</style>
